import { Checkbox } from "@app/scripts/react-general-components/Checkbox";
import { FilterProps } from "@usereactify/search";
import React, { useCallback, useEffect } from "react";

import { FilterSortDrawerItem } from "@app/scripts/reactify/filters/FilterSortDrawerItem";

type FilterRangeProps = React.ComponentProps<NonNullable<FilterProps["renderFilterRange"]>>;

export const FilterRange: React.FC<FilterRangeProps> = (props) => {
  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      props.filterRangeProps.handleChange(event.target.value);
    },
    [props.filterRangeProps]
  );

  useEffect(() => {
    window.selectedFilters = {
      ...(window.selectedFilters || {}),
      [props?.filter?.handle]: props?.filterRangeProps?.values?.length || 0
    }

    const activeFilters = document.querySelectorAll(".active-filters")
    if (activeFilters?.length) {
      activeFilters?.forEach((item) => item.innerHTML = `(${Object.values<any>(window.selectedFilters).reduce((sum: number, value: number) => sum + value, 0)})`)
    }
  }, [props?.filterRangeProps?.values])

  return (
    <FilterSortDrawerItem id={props.filter.id} title={props.filter.name}>
      <div className="rs__filter">
        <div className="rs__range">
          {props.filterRangeProps.options.map((option) => (
            <Checkbox
              key={option.key}
              value={option.key}
              checked={option.checked}
              label={option.label}
              onChange={onChange}
            />
          ))}
        </div>
      </div>
    </FilterSortDrawerItem>
  );
};
